<template>
    <div class="home">
        <iframe
        sandbox="allow-scripts allow-popups" 
        :src="iframeSrc"
        title="Earth Blox | All the power of Earth Engine without the coding"
        ></iframe>
    </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { earthbloxCollection } from "@/firebase.js";

export default {
  name: "Home",
    data: () => ({
        iframeSrc: "https://www.earthblox.io/logout",
    }),
  created() {
    console.log("Home.vue  created");
    earthbloxCollection.doc("homepage").onSnapshot(function(doc) {
        if (doc.exists && doc.data().homeSrc && doc.data().homeSrc !== '') {
            this.iframeSrc = doc.data().homeSrc;
        }
    }.bind(this));
    
  }, //ends created
}; // export
</script>

<style scoped lang="scss">
.home {
  height: 100%;
}

.home iframe {
  display: block;
  width: 100%;
  height: calc(100% - 48px);
  position: absolute;
  top: 48px;
  left: 0;
  right: 0;
  border: 0;
}

@media (min-width: 961px) {
  .home iframe {
    height: calc(100% - 64px);
    top: 64px;
  }
}
</style>